import * as React from "react";
import classNames from "classnames";
import { Tag as UITag, TagProps as UITagProps } from "@stemscopes/ui";
import { Icon } from "components";
import styles from "./Tag.module.css";

export type TagProps = {
  type?: "warning" | "danger" | "basic" | "primary" | "success" | "info";
  clear?: boolean;
  uppercase?: boolean;
  iconOnly?: boolean;
} & UITagProps;

const Tag = ({
  type,
  clear,
  className,
  uppercase = false,
  iconOnly,
  ...rest
}: TagProps): React.JSX.Element => {
  const [hovered, setHovered] = React.useState(false);

  return (
    // eslint-disable-next-line
    // @ts-ignore
    <UITag
      {...rest}
      onCloseEnter={() => setHovered(true)}
      onCloseLeave={() => setHovered(false)}
      className={classNames(styles.wrapper, className, type && styles[type], {
        [styles.uppercase]: uppercase,
        [styles.clear]: clear,
        [styles.iconOnly]: iconOnly,
      })}
      closeIcon={
        <Icon
          name={hovered ? "close-circle-filled" : "close-circle-outlined"}
        />
      }
    />
  );
};

export default Tag;
